import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom-v5-compat';

import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import { searchWithTab } from '../../utils/appeals-v2-helpers';

// Wraps a legacy tab route. Flag-off renders the tab's container (or, with no
// element, the legacy ../status recovery redirect); flag-on redirects to the
// canonical ?tab= URL. searchWithTab overwrites any ?tab= already present, so
// a legacy subpath wins over a conflicting query.
export default function ClaimTabRoute({ element = null, tab }) {
  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  const useVaTabs = useToggleValue(TOGGLE_NAMES.cstClaimDetailsVaTabs);
  const { search, hash } = useLocation();

  if (!useVaTabs) {
    return element ?? <Navigate to="../status" replace />;
  }
  return (
    <Navigate
      to={{ pathname: '..', search: searchWithTab(search, tab), hash }}
      replace
    />
  );
}

ClaimTabRoute.propTypes = {
  tab: PropTypes.string.isRequired,
  element: PropTypes.node,
};
